import 'select2';
import CustomSelect from "./CustomSelect";
new CustomSelect();
